enum DisbursalTypeEnum {
    Drawdown = 'DRAWDOWN',
    Full = 'FULL',
    Tranched = 'TRANCHED',
}

export default DisbursalTypeEnum;
